import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function CommunityUsage() {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle>Third-Party Usage Analytics</CardTitle>
        <p className="text-sm text-muted-foreground">
          How others are using your ciphers
        </p>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground py-4">
          Cross-tenant usage aggregation lands with the cipher_usage_events
          rollup in Phase 06.
        </p>
      </CardContent>
    </Card>
  );
}
